import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const SelectorWrapper = styled.div``;

const CurrentZoneSelectorWrapper = ({ children }) => (
  <SelectorWrapper>{children}</SelectorWrapper>
);

CurrentZoneSelectorWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CurrentZoneSelectorWrapper;
